<template>
  <div class="scan">
    <div>
      <div class="scan-title">扫码关注</div>
      <div class="scan-content">
        <img src="@/assets/img/upload/mp.png"/>
        <p>关注 明基专业摄影显示器 公众号</p>
        <p>大赛资讯，尽在掌握</p>
      </div>
      <!-- <div class="scan-button">
        <el-button
          size="small"
          type="primary"
          class="button-inline"
          @click="confirm"
          >确定</el-button
        >
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
  },
  data() {
    return {
    }
  },
  computed: {},
  watch: {},
  created() {
  },
  mounted() { },
  methods: {
    confirm() {
      this.$emit('confirm');
    }
  }
}
</script>
<style lang="scss" scoped>
.scan {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 100;
  & > div {
    width: 550px;
    height: 750px;
    background-color: #f0f0f0;
    border-radius: 6px;
    margin: 120px auto auto auto;
    opacity: 1;
    .scan-title {
      text-align: center;
      padding: 50px 0 30px 0;
      font-weight: bold;
      font-size: 36px;
    }
    .scan-content {
      margin: 0 35px 40px 35px;
      width: 430px;
      height: 430px;
      background-color: #ffffff;
      border-radius: 6px;
      padding: 35px 25px;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
      color: #313133;
      img {
        width: 256px;
        height: 256px;
        margin-top: 35px;
        margin-bottom: 40px;
      }
      p{
        margin-bottom: 15px;
        text-align: center;
      }
    }
    .scan-button {
      width: 150px;
      height: 40px;
      margin: 0 auto;
      .button-inline {
        width: 150px;
        height: 40px;
      }
    }
  }
}
</style>
